import React from "react";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
  const navigate = useNavigate();

  const dashboardCards = [
    {
      title: "Kategorie",
      description: "Zarządzaj kategoriami postów i harmonogramów",
      icon: "📁",
      path: "/categories",
      color: "bg-blue-500",
      hoverColor: "hover:bg-blue-600",
    },
    {
      title: "Harmonogramy",
      description: "Twórz i edytuj szablony harmonogramów",
      icon: "📋",
      path: "/templates",
      color: "bg-green-500",
      hoverColor: "hover:bg-green-600",
    },
    {
      title: "Posty",
      description: "Zarządzaj artykułami i treściami",
      icon: "📝",
      path: "/post",
      color: "bg-purple-500",
      hoverColor: "hover:bg-purple-600",
    },
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Panel Administracyjny
        </h1>
        <p className="text-gray-600">Witaj w panelu zarządzania treścią</p>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {dashboardCards.map((card, index) => (
          <div
            key={index}
            onClick={() => navigate(card.path)}
            className="bg-white rounded-lg shadow-md p-6 cursor-pointer transform transition-all duration-200 hover:scale-105 hover:shadow-lg border border-gray-200"
          >
            <div className="flex items-center justify-between mb-4">
              <div
                className={`${card.color} w-12 h-12 rounded-lg flex items-center justify-center text-white text-2xl`}
              >
                {card.icon}
              </div>
              <svg
                className="w-5 h-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {card.title}
            </h3>
            <p className="text-gray-600 text-sm">{card.description}</p>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Szybkie akcje
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <button
            onClick={() => navigate("/post/new")}
            className="flex items-center p-4 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg transition-colors text-left"
          >
            <div className="bg-blue-500 w-10 h-10 rounded-lg flex items-center justify-center text-white mr-3">
              ➕
            </div>
            <div>
              <div className="font-medium text-gray-900">Nowy post</div>
              <div className="text-sm text-gray-600">Utwórz nowy artykuł</div>
            </div>
          </button>

          <button
            onClick={() => navigate("/categories")}
            className="flex items-center p-4 bg-green-50 hover:bg-green-100 border border-green-200 rounded-lg transition-colors text-left"
          >
            <div className="bg-green-500 w-10 h-10 rounded-lg flex items-center justify-center text-white mr-3">
              🏷️
            </div>
            <div>
              <div className="font-medium text-gray-900">
                Zarządzaj kategoriami
              </div>
              <div className="text-sm text-gray-600">
                Dodaj lub edytuj kategorie
              </div>
            </div>
          </button>

          <button
            onClick={() => navigate("/templates")}
            className="flex items-center p-4 bg-purple-50 hover:bg-purple-100 border border-purple-200 rounded-lg transition-colors text-left"
          >
            <div className="bg-purple-500 w-10 h-10 rounded-lg flex items-center justify-center text-white mr-3">
              📄
            </div>
            <div>
              <div className="font-medium text-gray-900">Nowy szablon</div>
              <div className="text-sm text-gray-600">
                Utwórz szablon harmonogramu
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
